import { useQuery } from "@tanstack/react-query";
import { getClientCredentialsApiV1ClientCredentialGet } from "@/client";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { DeleteClientCredentialDialog } from "./DeleteClientCredentialDialog";

export function ClientCredentialList() {
  const { data: clientCredentials } = useQuery({
    queryKey: ["client-credentials"],
    queryFn: () => getClientCredentialsApiV1ClientCredentialGet(),
  });

  return (
    <Card>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Client ID</TableHead>
              <TableHead>Scope</TableHead>
              <TableHead>Created At</TableHead>
              <TableHead>Delete</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {clientCredentials?.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={7}
                  className="pointer-events-none h-32 text-center align-middle text-muted-foreground"
                >
                  No client credentials found
                </TableCell>
              </TableRow>
            ) : (
              clientCredentials?.map((clientCredential) => (
                <TableRow key={clientCredential.id}>
                  <TableCell>{clientCredential.id}</TableCell>
                  <TableCell>{clientCredential.scope?.join(", ")}</TableCell>
                  <TableCell>{clientCredential.created_at?.toLocaleString()}</TableCell>
                  <TableCell>
                    <DeleteClientCredentialDialog clientSecretId={clientCredential.id} />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
